// Hidden developer mode (unlocked per device from Settings: tap the version
// footer 7 times, then enter the developer code). Hidden, not secure: never put
// secrets or privileged actions behind it; those must use server-authorized APIs.

const DEV_MODE_KEY = "inyc_dev_mode";

// SHA-256 hex of the developer code (the code itself is never stored).
// To set/change it: read -s -p "code: " c && printf %s "$c" | sha256sum | cut -d' ' -f1; unset c
export const DEV_CODE_HASH = "3153bb357017da310b73fe6d6ecdc7d6e5e9e7faff482ec9c4c5ab25544f29f3";

export const isDevMode = () => {
  try {
    return localStorage.getItem(DEV_MODE_KEY) === "1";
  } catch {
    return false;
  }
};

export const setDevMode = (enabled) => {
  try {
    if (enabled) localStorage.setItem(DEV_MODE_KEY, "1");
    else localStorage.removeItem(DEV_MODE_KEY);
  } catch {
    // storage unavailable (private mode etc.)
  }
};

const sha256Hex = async (text) => {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, "0"))
    .join("");
};

export const checkDevCode = async (code) => {
  if (!DEV_CODE_HASH || !code || !globalThis.crypto?.subtle) return false;
  return (await sha256Hex(code)) === DEV_CODE_HASH;
};
